import React from 'react';
import { Mail, FileText, Presentation, Video, Linkedin, FileCheck, MessageSquare, Monitor } from 'lucide-react';

const FORMAT_ICONS = {
  email_court: <Mail size={16} />,
  lettre_formelle: <FileText size={16} />,
  pitch: <Presentation size={16} />,
  script_video: <Video size={16} />,
  post_linkedin: <Linkedin size={16} />,
  one_pager: <FileCheck size={16} />,
  sms: <MessageSquare size={16} />,
  presentation: <Monitor size={16} />,
};

const CommFormatSelector = ({ formats, onSelect }) => {
  if (!formats || formats.length === 0) return null;

  return (
    <div style={{ marginBottom: 8 }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>
        Formats recommandés — cliquez pour choisir
      </div>
      <div style={{ display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 4 }}>
        {formats.map((f, i) => (
          <button
            key={f.id || i}
            onClick={() => onSelect(f.id)}
            style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6,
              padding: '10px 16px', borderRadius: 10, minWidth: 110,
              background: 'var(--card-bg)', border: '1px solid var(--card-border)',
              cursor: 'pointer', transition: 'all 0.15s', textAlign: 'center',
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = '#8b5cf6'; e.currentTarget.style.background = 'var(--accent-light)'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--card-border)'; e.currentTarget.style.background = 'var(--card-bg)'; }}
          >
            <div style={{ color: '#8b5cf6' }}>{FORMAT_ICONS[f.id] || <FileText size={16} />}</div>
            <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text)' }}>{f.label || f.id}</div>
            {f.score && (
              <div style={{ fontSize: 10, color: 'var(--text-muted)' }}>Score: {f.score}/10</div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CommFormatSelector;
